import { render, staticRenderFns } from "./KeywordsStatusManager.vue?vue&type=template&id=51300345"
import script from "./KeywordsStatusManager.vue?vue&type=script&lang=js"
export * from "./KeywordsStatusManager.vue?vue&type=script&lang=js"
import style0 from "./KeywordsStatusManager.vue?vue&type=style&index=0&id=51300345&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports